"use client";

import { Theme, theme } from "@/config/theme";
import { SCNoStyleButton } from "@/utils/styledComponents";
import styled from "styled-components";

interface FAQTabItem {
    id: string;
    name: string;
}

const FAQTabItem = ({
    item,
    currentTab,
    handleClick
}: {
    item: FAQTabItem;
    currentTab: string;
    handleClick: (tab: string) => void;
}) => {
    return (
        <SCFAQTabItem
            $isCurrentTab={currentTab === item.id}
            onClick={() => handleClick(item.id)}
        >
            {item.name}
        </SCFAQTabItem>
    );
};

export default FAQTabItem;

const SCFAQTabItem = styled(SCNoStyleButton)<{
    $isCurrentTab: boolean;
    theme: Theme;
}>`
    background-color: ${(props) =>
        props.$isCurrentTab
            ? theme["color-faq-purple"]
            : theme["color-light-grey"]};
    color: ${(props) =>
        props.$isCurrentTab ? theme["color-white"] : theme["color-black"]};
    padding: ${theme["spacing-s"]} ${theme["spacing-m"]};
    border-radius: ${theme["border-radius"]};
    cursor: pointer;
`;
